import { RequestFormView } from "@/Views/RequestFormView";
import { Navigate, useLocation } from "react-router-dom";
import { RouteName, routes } from "./router";

export const OldRequestPathRedirect = () => {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const hasRequiredParams = queryParams.has('requestType');

    if (!hasRequiredParams) {
        return <Navigate to={routes[RouteName.REQUESTS].path} replace />;
    }

    return <RequestFormView />;
};
